import * as React from 'react';
import { useMemo } from 'react';
import { AutocompleteProps } from '@mui/material/Autocomplete/Autocomplete';
import { StyledAutocomplete } from './StyledAutocomplete';
import { StyledAutocompleteProps } from './types';

export function ComboBoxInput<T, Required extends boolean>(
  props: Omit<StyledAutocompleteProps<T, false, Required, true>, 'onChange'> & {
    onValueChanged: (value: T | null | string) => void;
  },
) {
  const { onValueChanged, ...rest } = props;
  const onChange: NonNullable<
    AutocompleteProps<T, false, Required, true>['onChange']
  > = useMemo(
    () => (e, item) => {
      onValueChanged(item);
    },
    [onValueChanged],
  );
  return (
    <StyledAutocomplete<T, false, Required, true>
      filterOptions={props.enableSearch ? undefined : noFilter}
      {...rest}
      freeSolo={true}
      multiple={false}
      onChange={onChange}
    />
  );
}
/*
 * Could be passed to `filterOptions` to disable filtering (i.e. always show all elements)
 */
function noFilter(options: any[]) {
  return options;
}
